module.exports = __webpack_public_path__ + "static/img/3.3d624a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/3.jpg
// module id = 9z9B
// module chunks = 1